import { render, staticRenderFns } from "./PagePrinter.vue?vue&type=template&id=fa527e14&scoped=true"
import script from "./PagePrinter.vue?vue&type=script&lang=js"
export * from "./PagePrinter.vue?vue&type=script&lang=js"
import style0 from "./PagePrinter.vue?vue&type=style&index=0&id=fa527e14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa527e14",
  null
  
)

export default component.exports